var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-aw",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39c",
    d: "M0 0v512.006h768.01V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M0 341.338v28.445h768.01v-28.445H0zm0 56.889v28.445h768.01v-28.445H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M122.065 28.067l2.38 2.38-2.38-2.38zm-2.38 4.76l2.38 2.38-2.38-2.38m4.76 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M119.685 35.208l2.38 2.38-2.38-2.38m4.76 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M117.305 39.97l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "M122.065 39.97l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M126.826 39.97l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M117.305 42.35l2.38 2.38-2.38-2.38zm9.521 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M119.685 44.73l2.38 2.38-2.38-2.38m4.76 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M114.924 47.11l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.673 32.904L104.986 96.16l-63.442 17.23 63.26 16.51 16.87 63.257L138.54 129.9l63.26-16.87-63.26-16.87-16.867-63.256z",
    stroke: "#fff",
    strokeWidth: 2.975,
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M129.207 47.11l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M114.924 49.49l2.38 2.38-2.38-2.38m14.283 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M117.305 51.87l2.38 2.38-2.38-2.38m9.52 0l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M112.544 54.25l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M118.097 55.84l.794 1.585-.793-1.586m9.522 0l.793 1.585-.794-1.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M131.587 54.25l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M112.544 56.63l2.38 2.382-2.38-2.38m19.043 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M114.924 59.012l2.38 2.38-2.38-2.38m14.283 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M110.163 61.392l2.38 2.38-2.38-2.38zm23.805 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M110.163 63.773l2.38 2.38-2.38-2.38m23.805 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M110.163 66.153l2.38 2.38-2.38-2.38m23.805 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M107.783 68.533l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M112.544 68.533l2.38 2.38-2.38-2.38m19.043 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M136.348 68.533l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M107.783 70.914l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M113.337 72.502l.793 1.586-.793-1.586m19.043 0l.793 1.586-.793-1.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M136.348 70.914l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M107.783 73.294l2.38 2.38-2.38-2.38m28.565 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M110.163 75.675l2.38 2.38-2.38-2.38m23.805 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M105.403 78.055l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M110.956 79.643l.794 1.586-.794-1.587m23.804 0l.794 1.586-.794-1.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M138.728 78.055l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M105.403 80.435l2.38 2.38-2.38-2.38m33.325 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M107.783 82.816l2.38 2.38-2.38-2.38m28.565 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M103.022 85.196l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M108.576 86.784l.793 1.587-.794-1.586m28.565 0l.794 1.587-.793-1.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M141.11 85.196l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M103.022 87.577l2.38 2.38-2.38-2.38m38.087 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M105.403 89.957l2.38 2.38-2.38-2.38m33.325 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M100.642 92.337l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M105.403 92.337l2.38 2.38-2.38-2.38m33.325 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M143.49 92.337l2.38 2.38-2.38-2.38m-49.99 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M95.88 94.718l2.382 2.38-2.38-2.38m52.368 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M150.63 94.718l2.38 2.38-2.38-2.38m-64.27 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M88.74 97.098l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M98.26 97.098l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M100.642 97.098l2.38 2.38-2.38-2.38m42.847 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M145.87 97.098l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M155.39 97.098l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M157.77 97.098l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M76.838 99.48l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M79.218 99.48l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M81.6 99.48l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M91.12 99.48l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M95.088 100.27l1.587.795-1.587-.794m54.75 0l1.586.795-1.586-.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M153.01 99.48l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M162.532 99.48l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M164.913 99.48l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M167.293 99.48l2.38 2.38-2.38-2.38m-97.596 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M72.077 101.86l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M74.457 101.86l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M83.98 101.86l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M87.947 102.652l1.587.793-1.587-.793m69.032 0l1.586.793-1.587-.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M160.152 101.86l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M169.673 101.86l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M172.054 101.86l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M174.434 101.86l2.38 2.38-2.38-2.38m-111.88 2.38l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M64.936 104.24l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M76.838 104.24l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M80.806 105.032l1.587.794-1.587-.794m83.314 0l1.587.794-1.587-.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M167.293 104.24l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M179.195 104.24l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M181.575 104.24l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M55.414 106.62l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M57.795 106.62l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M67.316 106.62l2.38 2.38-2.38-2.38zm109.499 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M186.336 106.62l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M188.717 106.62l2.38 2.38-2.38-2.38M48.273 109l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M50.654 109l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M60.175 109l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M64.143 109.793l1.587.793-1.587-.793m116.64 0l1.587.793-1.587-.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M183.956 109l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M193.477 109l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M195.858 109l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M41.132 111.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M43.512 111.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M53.034 111.38l2.38 2.38-2.38-2.38zm138.063 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M200.62 111.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M203 111.38l2.38 2.38-2.38-2.38m-166.63 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "M48.273 113.76l2.38 2.38-2.38-2.38zm147.585 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M207.76 113.76l2.38 2.38-2.38-2.38m-166.628 2.38l2.38 2.382-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M43.512 116.14l2.38 2.382-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M53.034 116.14l2.38 2.382-2.38-2.38m138.063 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M200.62 116.14l2.38 2.382-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M203 116.14l2.38 2.382-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M48.273 118.522l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M50.654 118.522l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M60.175 118.522l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M64.143 119.314l1.587.794-1.587-.794m116.64 0l1.587.794-1.587-.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M183.956 118.522l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M193.477 118.522l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M195.858 118.522l2.38 2.38-2.38-2.38m-140.444 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M57.795 120.902l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M67.316 120.902l2.38 2.38-2.38-2.38zm109.499 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M186.336 120.902l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M188.717 120.902l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M62.555 123.283l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M64.936 123.283l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M76.838 123.283l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M80.806 124.075l1.587.794-1.587-.795m83.314 0l1.587.794-1.587-.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M167.293 123.283l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M179.195 123.283l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M181.575 123.283l2.38 2.38-2.38-2.38m-111.878 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M72.077 125.663l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M74.457 125.663l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M83.98 125.663l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M87.947 126.456l1.587.793-1.587-.794m69.032 0l1.586.793-1.587-.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M160.152 125.663l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M169.673 125.663l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M172.054 125.663l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M174.434 125.663l2.38 2.38-2.38-2.38m-97.596 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M79.218 128.043l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M81.6 128.043l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M91.12 128.043l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M95.088 128.836l1.587.794-1.587-.794m54.75 0l1.586.794-1.586-.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M153.01 128.043l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M162.532 128.043l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M164.913 128.043l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M167.293 128.043l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M86.36 130.424l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M88.74 130.424l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M98.26 130.424l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M100.642 130.424l2.38 2.38-2.38-2.38m42.847 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M145.87 130.424l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M155.39 130.424l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M157.77 130.424l2.382 2.38-2.38-2.38m-64.27 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M95.88 132.804l2.382 2.38-2.38-2.38m52.368 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M150.63 132.804l2.38 2.38-2.38-2.38m-49.988 2.38l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M105.403 135.185l2.38 2.38-2.38-2.38m33.325 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M143.49 135.185l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M105.403 137.565l2.38 2.38-2.38-2.38m33.325 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M103.022 139.945l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M108.576 141.533l.793 1.587-.794-1.587m28.565 0l.794 1.587-.793-1.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M141.11 139.945l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M103.022 142.326l2.38 2.38-2.38-2.38m38.087 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M107.783 144.706l2.38 2.38-2.38-2.38m28.565 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M105.403 147.087l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M110.956 148.674l.794 1.587-.794-1.586m23.804 0l.794 1.587-.794-1.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M138.728 147.087l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M105.403 149.467l2.38 2.38-2.38-2.38m33.325 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M110.163 151.847l2.38 2.38-2.38-2.38m23.805 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M107.783 154.228l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M113.337 155.816l.793 1.586-.793-1.586m19.043 0l.793 1.586-.793-1.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M136.348 154.228l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M107.783 156.608l2.38 2.38-2.38-2.38m28.565 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M107.783 158.99l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M112.544 158.99l2.38 2.38-2.38-2.38m19.043 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M136.348 158.99l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "M110.163 161.37l2.38 2.38-2.38-2.38zm23.805 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M110.163 163.75l2.38 2.38-2.38-2.38m23.805 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M110.163 166.13l2.38 2.38-2.38-2.38m23.805 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M114.924 168.51l2.38 2.38-2.38-2.38m14.283 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M112.544 170.89l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "M118.097 172.478l.794 1.587-.793-1.587m9.522 0l.793 1.587-.794-1.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M131.587 170.89l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "M112.544 173.27l2.38 2.38-2.38-2.38m19.043 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M117.305 175.65l2.38 2.382-2.38-2.38m9.52 0l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "M114.924 178.032l2.38 2.38-2.38-2.38zm14.283 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M114.924 180.412l2.38 2.38-2.38-2.38m14.283 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "M119.685 182.793l2.38 2.38-2.38-2.38m4.76 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M117.305 185.173l2.38 2.38-2.38-2.38m9.52 0l2.382 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M117.305 187.553l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "M122.065 187.553l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "M126.826 187.553l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "M119.685 192.314l2.38 2.38-2.38-2.38m4.76 0l2.38 2.38-2.38-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "M119.685 194.695l2.38 2.38-2.38-2.38m4.76 0l2.38 2.38-2.38-2.38m-2.38 4.76l2.38 2.38-2.38-2.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAw);
export default __webpack_public_path__ + "static/media/aw.f6ec5a962bdc3414c3f7451842433196.svg";
export { ForwardRef as ReactComponent };